module.exports = __webpack_public_path__ + "static/map-costa-rica-e3a1c351b95d97bb37ab0cb6662d497f.png";